import {Controller, useFormContext} from 'react-hook-form'
import {TextArea} from '@/components/atoms'
import {TextInputField} from '@/components/molecules'
import {useIntl} from 'react-intl'

const FormInputController = ({
  name,
  inputType,
  onChange,
  labelText,
  helperText,
  placeholderText,
  fieldProps,
  hideLabel,
  trim = false,
  maxLength = null
}) => {
  const {control} = useFormContext()
  const {formatMessage} = useIntl()
  let InputComponent
  const optionalProps = {}
  const uiSchemaProps = {
    label: formatMessage({id: labelText}),
    placeholder: formatMessage({id: placeholderText}),
    helperText: helperText ? formatMessage({id: helperText}) : null,
    isDark: true,
    showToolbar: false,
  }
  
  if (maxLength) {
    uiSchemaProps.maxLength = maxLength
  }
  
  switch (inputType) {
    case 'textarea':
      InputComponent = TextArea
      optionalProps.trim = trim
      break
    case 'text':
    default:
      InputComponent = TextInputField
      break
  }
  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => (
        <InputComponent
          isDark
          value={field.value}
          updateValue={onChange(field)}
          label={hideLabel ? null : formatMessage({id: labelText})}
          {...optionalProps}
          uiSchema={uiSchemaProps}
          {...fieldProps}
        />
      )}
    />
  )
}

export default FormInputController
